import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// Neo-brutalist pill button. variant: "primary" | "ghost" | "white"
export const PillButton = ({
  children,
  to,
  href,
  onClick,
  type,
  variant = "primary",
  className = "",
  testid,
  disabled = false,
}) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full font-heading font-bold text-base px-7 py-3.5 border-2 border-black transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-[#0033A2]/50 disabled:opacity-60 disabled:cursor-not-allowed";
  const variants = {
    primary:
      "bg-[#0033A2] text-white shadow-hard-sm hover:shadow-none hover:translate-x-[3px] hover:translate-y-[3px]",
    white:
      "bg-white text-black shadow-hard-blue-sm hover:shadow-none hover:translate-x-[3px] hover:translate-y-[3px]",
    ghost:
      "bg-transparent text-black border-black hover:bg-black hover:text-white",
  };
  const cls = `${base} ${variants[variant]} ${className}`;

  const content = (
    <motion.span
      whileTap={{ scale: 0.95 }}
      className="inline-flex items-center gap-2"
    >
      {children}
    </motion.span>
  );

  if (to) {
    return (
      <Link to={to} className={cls} data-testid={testid} onClick={onClick}>
        {content}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} data-testid={testid} onClick={onClick}>
        {content}
      </a>
    );
  }
  return (
    <button
      type={type || "button"}
      onClick={onClick}
      className={cls}
      data-testid={testid}
      disabled={disabled}
    >
      {content}
    </button>
  );
};

// Brand text logo
export const Logo = ({ light = false, className = "" }) => (
  <span
    className={`font-heading font-black tracking-tighter text-2xl ${className}`}
  >
    <span className={light ? "text-white" : "text-[#0033A2]"}>grooh</span>
    <span className={light ? "text-white" : "text-[#0033A2]"}>.</span>
  </span>
);
